import { axiosClient } from 'api/config/axiosClient';
const API_BASE = '/api/v1/users/me';
/**
 * API clients for my-account-app-xsvc service
 * Note: Rmd-User-Id header is automatically set by K8s ingress controller
 */
export class ApplicationsApi {
    static getUserApplications() {
        return axiosClient.get(`${API_BASE}/applications`);
    }
}
export class UserApi {
    static getUser() {
        return axiosClient.get(API_BASE);
    }
    static updateUserProfile(userProfile) {
        return axiosClient.put(API_BASE, userProfile);
    }
}
export class CredentialApi {
    static updateUserPasswordCredential(credentials) {
        return axiosClient.put(`${API_BASE}/credentials/password`, credentials);
    }
}
export class FactorsApi {
    static getUserEnrolledFactors() {
        return axiosClient.get(`${API_BASE}/factors`);
    }
    static getUserAvailableFactors() {
        return axiosClient.get(`${API_BASE}/factors/available`);
    }
}
